import createQueryClient from "openapi-react-query";
import type { ApiClient } from "./index";
import type { paths } from "./schema";

/**
 * TanStack Query hooks bound to the typed client:
 * `const api = createApiHooks(client); api.useQuery("get", "/healthz")`.
 */
export function createApiHooks(client: ApiClient) {
  return createQueryClient<paths>(client);
}

export type ApiHooks = ReturnType<typeof createApiHooks>;
